// const baseUrl = 'http://216.48.182.23:2121/user'
// http://sweetznsnackz.objectsquare.in/

// // for deployed on ip address
// const baseUrl = 'http://13.127.53.157:2121/user'
// const baseUrlAdmin = 'http://13.127.53.157:2121/admin'
// const imgUrl = 'http://13.127.53.157:2121/';

// for deployed on production
// const baseUrl = 'https://sweetznsnackzapi.objectsquare.in/user'
// const baseUrlAdmin = 'https://sweetznsnackzapi.objectsquare.in/admin'
// const imgUrl = 'https://sweetznsnackzapi.objectsquare.in';
// const baseUrlAdmin = 'https://sweetznsnackzapi.objectsquare.in/admin'
// const imgUrl = 'https://sweetznsnackzapi.objectsquare.in';
// const baseUrlAdmin = 'https://sweetznsnackzapi.objectsquare.in/admin'
// const imgUrl = 'https://sweetznsnackzapi.objectsquare.in';

// // for development
const baseUrl = "http://localhost:2121/user";
const baseUrlAdmin = "http://localhost:2121/admin";
const imgUrl = "http://localhost:2121/";

module.exports = { baseUrl, baseUrlAdmin, imgUrl };
